module.exports = __webpack_public_path__ + "media/post-listing-block-5-image.5e703aa8.jpg";